import norskPensjonReducer, { getInitialState } from "./norskPensjonReducer";

export { getInitialState };
export default norskPensjonReducer;
